








































































import { TriCarrierPerformance, TriTrip } from 'gl-ms-trips';
import glDispopicker from 'gl-uikit/src/components/gl-dispopicker.vue';
import carrierPerformance, { CarrierPerformanceExclusionRequestModel, CarrierPerformanceExclusionStatus } from '@/services/carrierPerformance';
import { getUserData } from '@/services/auth';
import storage from '@/services/storage';
import { ACTION_GET_TRIP_DETAILS, ACTION_PENALTIES_EXCLUSION_REQUEST_DETAIL, ACTION_SAVE_PENALTIES_EXCLUSION_REQUEST } from '../../store/modules/carrierPerformance';
import tripSummary from './tripSummary.vue';
import tripDetails from './tripDetails.vue';

export default {
    data(this: any) {
        return {
            loading: false,
            id_trip: '',
            isNewRequest: true,
            exclusionRequestForm: {
                requestComment: '',
                feedbackComment: '',
            },
            rules: {
                requestComment: [
                    {
                        required: true,
                        message: this.$t('carrierPerformance.pls_entr_request_comment'),
                        trigger: ['blur', 'change'],
                    },
                ],
            },
        };
    },
    components: {
        glDispopicker,
        tripSummary,
        tripDetails,
    },
    watch: {
        async id_trip(this: any) {
            await this.getTripDetails();
        },
    },
    async mounted(this: any) {
        if (this.$route.query.id_trip) {
            this.id_trip = this.$route.query.id_trip;
        }
    },
    computed: {
        tripData(this: any) {
            return this.$store.getters.getTripDetails;
        },
        performanceSummary(this: any) {
            return this.$store.getters.getPerformanceSummary.filter((q: TriCarrierPerformance) => q.showPlace || q.isDocument);
        },
        isAllEventsOk(this: any) {
            return this.performanceSummary.length > 0 ? !this.performanceSummary.some((q: TriCarrierPerformance) => !q.isFilled_before_limit) : false;
        },
        isEdit(this: any) {
            return !!this.$route.query.id_trip;
        },
        showNewRequestButton(this: any) {
            return ((this.isCarrierPerformanceApprover && this.isNewRequest) || (this.canStatusChange && !this.isCarrierPerformanceApprover && this.isNewRequest)) && !this.isAllEventsOk;
        },
        isFeedbackCommentDisabled(this: any) {
            return (!this.canStatusChange && this.isCarrierPerformanceApprover) || this.isNewRequest;
        },
        isPerformanceSummaryCalculated(this: any) {
            return this.tripData && this.tripData.carrier_performance && this.tripData.carrier_performance.length > 0;
        },
        showApprovalButtons(this: any) {
            return this.canStatusChange && this.isCarrierPerformanceApprover && !this.isNewRequest;
        },
        getSelectedPenalty(this: any) {
            return this.$store.getters.getSelectedPenalty;
        },
        canStatusChange(this: any) {
            if (this.getSelectedPenalty && this.getSelectedPenalty.id_trip) {
                return this.getSelectedPenalty.Status == CarrierPerformanceExclusionStatus.PENDING;
            }
            return true;
        },
        isCarrierPerformanceApprover(this: any) {
            return carrierPerformance.isCarrierPerformanceApprover();
        },
    },
    methods: {
        async loadDispoData(this: any, idTrip: string) {
            this.id_trip = idTrip;
        },
        async getTripDetails(this: any): Promise<TriTrip | undefined> {
            if (!this.id_trip) return undefined;
            this.loading = true;
            await this.$store.dispatch(ACTION_GET_TRIP_DETAILS, this.id_trip);
            await this.$store.dispatch(ACTION_PENALTIES_EXCLUSION_REQUEST_DETAIL, this.id_trip);

            if (this.getSelectedPenalty && this.getSelectedPenalty.id_trip) {
                this.isNewRequest = false;
                this.setComments();
            } else {
                this.isNewRequest = true;
                this.$store.commit(ACTION_PENALTIES_EXCLUSION_REQUEST_DETAIL, {});
                this.exclusionRequestForm = {
                    requestComment: '',
                    feedbackComment: '',
                };
            }
            setTimeout(() => {
                this.loading = false;
            }, 200);
        },
        setComments(this: any) {
            if (this.getSelectedPenalty) {
                this.exclusionRequestForm.requestComment = this.getSelectedPenalty.Request_comment;
                this.exclusionRequestForm.feedbackComment = this.getSelectedPenalty.Feedback_comment;
            }
        },
        async saveForm(this: any, status: CarrierPerformanceExclusionStatus) {
            this.$refs.exclusionRequestForm.validate(async (valid: any) => {
                if (!valid) {
                    return false;
                }

                let feedbackObject = {};
                if (this.isCarrierPerformanceApprover && !this.isNewRequest) {
                    feedbackObject = {
                        Feedback: {
                            Feedback: status,
                            Comment: this.exclusionRequestForm.feedbackComment,
                        },
                    };
                }
                const user = getUserData();
                const body: CarrierPerformanceExclusionRequestModel = {
                    id_trip: this.tripData.id_trip,
                    Carrier_name: this.tripData.carrier ? this.tripData.carrier.company_name : '',
                    User_name: user.name || user.userName,
                    Status: status,
                    Request: {
                        Comment: this.exclusionRequestForm.requestComment,
                    },
                    ...feedbackObject,
                };

                await this.$store.dispatch(ACTION_SAVE_PENALTIES_EXCLUSION_REQUEST, body);
                this.redirectToList();
                return true;
            });
        },
        redirectToList(this: any) {
            const penaltiesTableQueryParam = storage.getSession('penaltiesTable');
            if (penaltiesTableQueryParam) {
                storage.setSession('penaltiesTable', '');
                this.$router.push({
                    name: 'all',
                    query: JSON.parse(penaltiesTableQueryParam),
                });
            } else {
                this.$router.push({ name: 'all' });
            }
        },
    },
};
